import { render, staticRenderFns } from "./editContract.vue?vue&type=template&id=3643ec7f&scoped=true"
import script from "./editContract.vue?vue&type=script&lang=js"
export * from "./editContract.vue?vue&type=script&lang=js"
import style0 from "./editContract.vue?vue&type=style&index=0&id=3643ec7f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643ec7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3643ec7f')) {
      api.createRecord('3643ec7f', component.options)
    } else {
      api.reload('3643ec7f', component.options)
    }
    module.hot.accept("./editContract.vue?vue&type=template&id=3643ec7f&scoped=true", function () {
      api.rerender('3643ec7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/editContract.vue"
export default component.exports